import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const TaskIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V5C18 4.44772 17.5523 4 17 4H7ZM14.4534 6.28924C14.846 6.67773 14.8493 7.31089 14.4608 7.70343L12.2108 9.97689C12.0229 10.1667 11.767 10.2735 11.5 10.2735C11.233 10.2735 10.9771 10.1667 10.7892 9.97689L9.78924 8.96646C9.40074 8.57392 9.40403 7.94076 9.79657 7.55227C10.1891 7.16378 10.8223 7.16706 11.2108 7.5596L11.5 7.85185L13.0392 6.29657C13.4277 5.90403 14.0609 5.90074 14.4534 6.28924ZM8 13C8 12.4477 8.44772 12 9 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H9C8.44772 14 8 13.5523 8 13ZM8 17C8 16.4477 8.44772 16 9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

TaskIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(TaskIcon);
